'use strict';
/**
 * @name setScrollTrigger.js
 * @description GSAP、ScrollTriggerを採用したスクロールアニメーション
 */
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
gsap.config({ nullTargetWarn: false, });

//プロパティ設定
let setPropaty = () => {
    return {
        html: document.querySelector('html'),
        Trigger: document.querySelectorAll('[data-trigger-wrap]'),
    }
}

//アニメーション設定
let props = () => {
    return {
        Action: { duration: 0.5, ease: 'power2.out', overwrite: true, },
        Trigger: { start: `top 65%`, end: `top 65%`, once: true },
        scrubParallaxBg: { start: `top 80%`, end: '80% top', scrub: 1, invalidateOnRefresh: true, },
        scrubParallaxItem: { start: `top bottom`, end: 'bottom top', scrub: 1.5, invalidateOnRefresh: true, },
    }
}

class setScrollTrigger {
    constructor() {
        this.propaty = setPropaty();
        this.props = props();
        // this.__kill(); //非同期遷移時にON

        //ページ判定
        this.__common();
    }

    /**
     * @name __animation
     * @description アニメーション設定
     */
    __animation() {

        // パララックス - 背景
        let parallaxBgEffect = (el) => {
            let triggerH = el.getBoundingClientRect().height;
            let parallaxItem = el.querySelector('img');
            let parallaxItemH = parallaxItem.clientHeight * 1.2;
            gsap.to(parallaxItem, { y: `${-(parallaxItemH - triggerH)}px`, ease: "none", scrollTrigger: { trigger: el, ...this.props.scrubParallaxBg }, })
        };

        // パララックス - 要素を下から上に移動
        let parallaxElBottomEffect = (wrap) => {
            let el = wrap.querySelectorAll('[data-plx-item]');
            let itemH = window.innerHeight;
            gsap.set(el, { y: `${itemH * 0.25}px` })
            gsap.to(el, { y: `-${itemH * 0.25}px`, ease: "none", scrollTrigger: { trigger: wrap, ...this.props.scrubParallaxItem } })
        }

        // パララックス - 要素を下から上に移動
        let parallaxElBottomEffectTop = (wrap) => {
            let el = wrap.querySelectorAll('[data-plx-top-item]');
            let itemH = window.innerHeight;
            gsap.to(el, { y: `-${itemH * 0.25}px`, ease: "none", scrollTrigger: { trigger: wrap, ...this.props.scrubParallaxItem } })
        }

        // トグル - クラス付与
        let toggleClassEffect = (el) => {
            gsap.to(el, {
                scrollTrigger: {
                    trigger: el,
                    ...this.props.Trigger,
                    toggleClass: 'isActive',
                }
            })
        }

        // フェードアップ
        let fadeUpEffect = (wrap) => {
            let el = wrap.querySelectorAll('[data-fade-up]');
            gsap.set(el, { y: 50, opacity: 0 });
            gsap.to(el, {
                y: 0, opacity: 1, ...this.props.Action,
                scrollTrigger: { trigger: wrap, ...this.props.Trigger, },
                stagger: 0.1,
            });
        }

        // フェードアップ
        let fadeUpLeftEffect = (wrap) => {
            let el = wrap.querySelectorAll('[data-fade-up-left]');
            gsap.set(el, { x: -50, opacity: 0 });
            gsap.to(el, {
                x: 0, opacity: 1, ...this.props.Action,
                scrollTrigger: { trigger: wrap, ...this.props.Trigger, },
                stagger: 0.1,
            });
        }

        return { parallaxBgEffect, parallaxElBottomEffect, parallaxElBottomEffectTop, toggleClassEffect, fadeUpEffect, fadeUpLeftEffect }
    }

    /**
     * @name __init
     * @description 初期設定
     * @param {*} getTrigger
     */
    __init(getTrigger) {

        // アニメーション適用
        const applyEffect = (selector, effectMethod) => {
            let items = getTrigger.querySelectorAll(selector);
            if (items.length == 0) return;
            items.forEach((trigger) => this.__animation()[effectMethod](trigger));
        }

        // パララックス - 背景
        const parallaxBg = () => {
            applyEffect('[data-plx-bg]', 'parallaxBgEffect');
        }

        // パララックス - 要素を下から上に移動
        const parallaxItem = () => {
            applyEffect('[data-plx-item-wrap]', 'parallaxElBottomEffect');
        }
        // パララックス - 要素を下から上に移動
        const parallaxTopItem = () => {
            applyEffect('[data-plx-item-wrap]', 'parallaxElBottomEffectTop');
        }

        // トグル - クラス付与
        const toggleClass = () => {
            applyEffect('[data-toggle-class]', 'toggleClassEffect');
        }

        // フェードアップ
        const fadeUp = () => {
            applyEffect('[data-fade-up-wrap]', 'fadeUpEffect');
        }

        // フェードアップ
        const fadeUpLeft = () => {
            applyEffect('[data-fade-up-wrap]', 'fadeUpLeftEffect');
        }

        return { parallaxBg, parallaxItem, parallaxTopItem, toggleClass, fadeUp, fadeUpLeft }
    }

    /**
     * @name __kill
     * @description ScrollTriggerの初期化
     */
    __kill() {
        ScrollTrigger.getAll().forEach(t => t.kill());
    }

    /**
     * @name __common
     * @description 全ページ共通設定
     */
    __common() {
        this.propaty.Trigger.forEach((getTrigger) => {
            let { parallaxBg, parallaxItem, parallaxTopItem, toggleClass, fadeUp, fadeUpLeft } = this.__init(getTrigger);
            parallaxBg();
            parallaxItem();
            parallaxTopItem();
            toggleClass();
            fadeUp();
            fadeUpLeft();
        });
    }
}

export default setScrollTrigger;